import React from 'react';

import { StepperContainer, Stepper as Step } from '../styles';

interface Props {
  index: number;
  count: number;
}

const extractIndex = (index: number) => {
  const last = parseInt(`${index}`.slice(`${index}`.length - 1), 36);

  if (last >= 5 && last <= 9) {
    return last - 5;
  }

  return last;
};

const Stepper = ({ index, count }: Props) => {
  const newIndex = extractIndex(index);

  const makeSize = (stepperIndex: number) => {
    if (!(newIndex === stepperIndex)) {
      let distance: number;
      let size: number;

      if (newIndex > stepperIndex) {
        distance = newIndex - stepperIndex;
        size = distance > 2 ? 4 : 6;
      } else {
        distance = stepperIndex - newIndex;
        size = distance > 2 ? 4 : 6;
      }
      return size;
    }
    return undefined;
  };

  return (
    <StepperContainer>
      {[...Array(count > 5 ? 5 : count)].map((_, i) => (
        <Step key={i.toString()} size={makeSize(i)} />
      ))}
    </StepperContainer>
  );
};

export default Stepper;
